const key = 'DEVICE__';

exports.DELETE_INVERTER_DATA = `${key}DELETE_INVERTER_DATA`;
exports.GENERAL_INFO = `${key}GENERAL_INFO`;
exports.INFO_SYSTEM = `${key}INFO_SYSTEM`;
exports.GENERAL_STATISTICS = `${key}GENERAL_STATISTICS`;
exports.TOTAL_STATISTICS = `${key}TOTAL_STATISTICS`;
exports.GRAPH_INITIAL_DATA = `${key}GRAPH_INITIAL_DATA`;
exports.GRAPH_BATTERY_DATA = `${key}GRAPH_BATTERY_DATA`;
exports.GRAPH_BATTERY_DATA_BOX_PLOT = `${key}GRAPH_BATTERY_DATA_BOX_PLOT`;
exports.DEVICE_ID = `${key}DEVICE_ID`;
exports.CONSULT_ATTRIBUTE = `${key}CONSULT_ATTRIBUTE`;
exports.CONSULT_ATTRIBUTE_BATTERY = `${key}CONSULT_ATTRIBUTE_BATTERY`;
exports.TYPE_CONSULT_BATTERY = `${key}TYPE_CONSULT_BATTERY`;
exports.TYPE_CONSULT_BATTERY_BOX_PLOT = `${key}TYPE_CONSULT_BATTERY_BOX_PLOT`;
exports.BATTERY_CONSULT = `${key}BATTERY_CONSULT`;
exports.SOC_CONSULT = `${key}SOC_CONSULT`;
exports.BOX_CONSULT = `${key}BOX_CONSULT`;
exports.HISTOGRAM_CONSULT = `${key}HISTOGRAM_CONSULT`;
exports.LOADING_ATTRIBUTE_GRAPH = `${key}LOADING_ATTRIBUTE_GRAPH`;
exports.LOADING_BATTERY_GRAPH = `${key}LOADING_BATTERY_GRAPH`;
exports.LOADING_BATTERY_GRAPH_BOX_PLOT = `${key}LOADING_BATTERY_GRAPH_BOX_PLOT`;
exports.LOADING_INFO_SYSTEM = `${key}LOADING_INFO_SYSTEM`;
exports.DATA_DEVICES_TABLE = `${key}DATA_DEVICES_TABLE`;
exports.ALL_INVERTERS_DATA = `${key}ALL_INVERTERS_DATA`;
exports.INFO_BUSINESS_TYPE = `${key}INFO_BUSINESS_TYPE`;
exports.ALL_DEVICES_DATA = `${key}ALL_DEVICES_DATA`;
exports.GENERAL_DEVICE_INFO = `${key}GENERAL_DEVICE_INFO`;
exports.EDGE_NAMES = `${key}EDGE_NAMES`;
exports.CONSULT_ATTRIBUTE_BATTERY_BOX_PLOT = `${key}CONSULT_ATTRIBUTE_BATTERY_BOX_PLOT`;
